import { createRequestTypes } from '../utils';

export const FETCH_SUBSTANCE_ACTIONS = createRequestTypes('substanceAction/FETCH_SUBSTANCE_ACTIONS');
export const LINK__COSANNEXE = createRequestTypes('substanceAction/LINK_COSANNEXE');
